module.exports = __webpack_public_path__ + "static/media/hand.eec4ee6c.svg";